import { Box, Text } from "@chakra-ui/react";
import React from "react";
import { useSelector } from "react-redux";
import Select from "react-select";

const colourStyles = {
  control: (styles) => ({
    ...styles,
    width: "100%",
    background: "white",
    color: "#690000",
    borderRadius: "16px",
  }),
  option: (styles) => ({
    ...styles,
    color: "#690000",
    whiteSpace: "normal",
  }),
  menu: (styles) => ({
    ...styles,
    zIndex: 9999,
  }),
  menuPortal: (styles) => ({
    ...styles,
    zIndex: 9999,
  }),
};

const SubjectFilterSelect = ({
  selectedSubjectId,
  setSelectedSubjectId,
  emptyHint,
}) => {
  const subjects = useSelector((state) => state.subjects.subjects);
  const subjectsOptions = subjects?.map((subject) => ({
    value: subject.id,
    label: subject.name,
  }));
  const selectedSubject =
    subjectsOptions?.find(
      (option) => String(option.value) === String(selectedSubjectId)
    ) || null;

  return (
    <>
      {emptyHint && !selectedSubjectId && (
        <Text w="100%" fontSize="16px" textAlign="right" color="gray.500">
          {emptyHint}
        </Text>
      )}
      <Box
        w="100%"
        maxW={{ base: "100%", md: "400px" }}
        alignSelf="flex-start"
        overflow="visible"
        position="relative"
        zIndex={20}
      >
        <Select
          options={subjectsOptions}
          value={selectedSubject}
          onChange={(data) => setSelectedSubjectId(data?.value || null)}
          styles={colourStyles}
          placeholder="اختر المادة"
          isClearable
          menuPortalTarget={typeof document !== "undefined" ? document.body : null}
          menuPosition="fixed"
          menuPlacement="auto"
        />
      </Box>
    </>
  );
};

export default SubjectFilterSelect;
